import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import { I18n } from 'aws-amplify';
import Utils from '@/common/utils/utils';
import { confirmRemoveAddingUser, submitDeleteProjectUser } from '../handler/ProjectUserManagementHandler';

function ConfirmDeleteUserProject({ openConfirmModal, argsAll }) {
    const userId = openConfirmModal.userId;
    const userList = !Utils.isEmptyArray(argsAll?.userList) ? argsAll?.userList : [];
    const isDeleteProjectUser = Utils.findIndexInArrayById(userId, userList) !== -1 ? true : false;

    const handleCloseConfirmModal = () => {
        argsAll.setOpenConfirmModal({ isOpen: false, userId: null });
    };

    const handleDeleteUser = () => {
        if (isDeleteProjectUser) {
            submitDeleteProjectUser(argsAll, userId);
        } else {
            confirmRemoveAddingUser(argsAll, openConfirmModal.userId );
        }

        argsAll.setOpenConfirmModal({ isOpen: false, userId: null });
    };

    return (
        <Dialog
            open={openConfirmModal.isOpen}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogContent>
                <div className="dialog-content">
                    {isDeleteProjectUser ? I18n.get('USER09MSG006') : I18n.get('USER12MSG005')}
                </div>
            </DialogContent>
            <DialogActions className="dialog-action-delete">
                <Button
                    className="dialog-button-delete"
                    variant="contained"
                    onClick={() => handleDeleteUser()}
                >
                    {I18n.get('COMBTN002')}
                </Button>
                <Button
                    className="dialog-action-cancel"
                    variant="contained"
                    onClick={() => handleCloseConfirmModal()}
                >
                    {I18n.get('COMBTN007')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ConfirmDeleteUserProject;
